import { TTDDialog } from "@excalidraw/excalidraw";

import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

import { generateMermaidFromText, hasGeminiApiKey } from "../data/gemini";

export const AIComponents = ({
  excalidrawAPI,
}: {
  excalidrawAPI: ExcalidrawImperativeAPI;
}) => {
  return (
    <>
      <TTDDialog
        onTextSubmit={async (input) => {
          if (!hasGeminiApiKey()) {
            return {
              error: new Error(
                "Gemini API key not configured. Please set it in settings.",
              ),
            };
          }

          try {
            const generatedResponse = await generateMermaidFromText({
              description: input,
              diagramType: "auto",
            });

            return {
              generatedResponse,
              rateLimit: undefined,
              rateLimitRemaining: undefined,
            };
          } catch (err: any) {
            return {
              error: new Error(err.message || "Failed to generate diagram"),
            };
          }
        }}
      />
    </>
  );
};
